const initialState = { code: '0.9.1' };

export default function versionReducer (state = initialState, action) {
  switch(action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/version.js